BillingFormUtil = require '../internal/billing-form-util'
FormFields = require './internal/form-fields'
React = require 'react'
_ = require 'underscore'
{
  countries,
  usTerritories,
} = require 'app/src/components/CreditCardForm/countries'
{
  hasTaxNumbers,
  getTaxType,
  requiresZipCode,
  isValidTaxId,
  isValidZipCode
} = require 'app/src/components/CreditCardForm/taxes'
f = require 'effing'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
xtend = require 'xtend'
{ PurchaseFormIds } = require '@trello/webdriverio-tests'


module.exports = class extends React.Component
  displayName: 'AddressTaxComponent'

  formFields: ['zipCode', 'country', 'taxId']
  requiredFields:
    country: /\S/
    zipCode: (value, { country }) ->
      !requiresZipCode(country) || isValidZipCode(value, country)
    taxId: (value, { country, zipCode }) ->
      isValidTaxId(value, country, zipCode)

  render: t.renderable ->
    { calculateSalesTax, calculateSalesTaxDebounced, errorField, resetSalesTax } = @props

    localizedCountries = @getLocalizedCountries()

    render = ({ getData, formState, setFormState }) =>
      { country, zipCode, taxId } = formState

      onTaxIdChange = (e) =>
        taxId = e.target.value
        setFormState { taxId }, =>
          # calculate sales tax if the tax code is valid
          if isValidTaxId(taxId, country, zipCode)
            calculateSalesTaxDebounced({ taxId, country, zipCode })

      onCountryChange = (e) ->
        if (!_.isFunction(resetSalesTax) || !_.isFunction(calculateSalesTax))
          return

        country = e.target.value

        resetSalesTax()
        setFormState { country, zipCode: '', taxId: '' }, =>
          calculateSalesTax({ country })

      onZipChange = (e) ->
        if (!_.isFunction(calculateSalesTax))
          return

        zipCode = e.target.value
        setFormState { zipCode }, =>
          if isValidZipCode(zipCode, country)
            taxOpts = if taxId then { taxId, country, zipCode } else { country, zipCode }
            calculateSalesTaxDebounced(taxOpts)

      t.div ->
        t.div '.u-clearfix', ->
          t.form ->
            t.div '.credit-card-form-section.u-clearfix', ->
              t.div '.credit-card-country', ->
                t.label ->
                  t.format 'country'
                  t.select onChange: onCountryChange, autoComplete: 'country', class: t.classify({ 'select-error': errorField == 'country' }), 'data-test-id': PurchaseFormIds.CreditCardCountrySelect, ->
                      for [value, name] in localizedCountries
                        t.option { value }, -> t.text name
                      return
                if errorField == 'country'
                  t.span '.u-form-error', ->
                    t.format 'must-be-a-valid-country'

              # collect zip codes for USA, Canada or US territories
              if (requiresZipCode(country))
                t.div '.credit-card-zip-code', ->
                  isErrored = 'zipCode' == errorField
                  errorLabelKey = if (country == 'US' or country in usTerritories) then 'us-addresses-require-a-zip-code' else 'please-enter-a-valid-postal-code'
                  t.label ->
                    t.format 'postal-code'
                    t.input
                      onChange: onZipChange
                      class: t.classify({ text: true, 'input-error': isErrored })
                      maxLength: '10'
                      'data-test-id': PurchaseFormIds.CreditCardZipCodeInput
                      size: '10'
                      autoComplete: 'postal-code'
                      placeholder: (if country == 'CA' then 'M4B 1G5' else '90210')
                      type: 'text'
                      value: zipCode
                    if isErrored
                      t.span '.u-form-error', ->
                        t.format errorLabelKey

        # Collect VAT/ABN for EU & Australia
        t.div class: t.classify({ 'tax-number': true, hide: !hasTaxNumbers(country, zipCode) }), ->
          isError = errorField == 'taxId'
          t.label { 'data-test-id': PurchaseFormIds.CreditCardTaxIdLabel }, ->
            t.format 'tax-number',
              taxType: getTaxType(country, zipCode)
            t.input { class: t.classify('input-error': isError, 'text': true), type: 'text', onChange: onTaxIdChange, value: taxId, 'data-test-id': PurchaseFormIds.CreditCardTaxIdInput }
          if isError
            t.p class: t.classify('u-form-error': true, error: true), 'data-test-id': PurchaseFormIds.CreditCardTaxIdValidationError, ->
              t.format 'please-enter-a-valid-tax-number'

    t.tag FormFields, {
      render
      @formFields
      @requiredFields
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      initialState: {
        country: countries.special[0][0]
        taxId: ''
        zipCode: ''
      }
    }

  getLocalizedCountries: ->
    countries.special.concat(countries.unloved)
